<template>
    <v-container>
        <v-row justify="end">
            <v-col sm="12" md="4" lg="4" xl="4">
                <v-text-field class="col" v-model="search" append-icon="mdi-magnify" label="Buscar cita" single-line
                    hide-details outlined dense @change="comp_change()"></v-text-field>
            </v-col>
        </v-row>
        <v-data-table :items-per-page="5" calculate-widths :headers="headers" :items="data" item-key="Id"
            :item-class="getRowClass" class="elevation-1 table-responsive" :search="search" :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
                'items-per-page-text': 'Filas por página',
            }" no-data-text="No existen citas en vigencia actual" fixed-header>
            <template v-slot:[`item.Folio`]="{ item }">
                <v-chip v-if="item.Id === resaltarId" color="green" text-color="white" small class="ml-2 nuevo-animado">
                    <v-icon left small>mdi-check-circle</v-icon>
                    Nuevo
                </v-chip> {{ item.Folio }}
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
                <td>
                    <span v-if="item.created_at">
                        {{ $formatDate(item.created_at) }}</span>
                    <span v-else><v-icon dense color="red darken-2"> mdi-close </v-icon>
                    </span>
                </td>
            </template>
            <template v-slot:[`item.FecCierre`]="{ item }">
                <div v-if="item.Externa">
                    <td class="azul_med--text">
                        EXTERNO
                    </td>
                </div>
                <div v-else>
                    <td v-if="item.FecCierre !== null">
                        CERRADA
                    </td>
                    <td v-else class="green--text">POR ASISTIR</td>
                </div>

            </template>
            <template v-slot:[`item.ops`]="{ item }">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <!-- <v-list-item v-show="item.FecCierre === null && !item.Externa">
                            <email-pase-medico :Id="item.Id" :propEmail="item.Email">
                            </email-pase-medico>
                        </v-list-item> -->
                        <v-list-item v-show="item.FecCierre === null && !item.Externa"
                            @click="$verPaseMedico(item.Id)"><v-icon dense color="grey darken-2">
                                mdi-eye-outline
                            </v-icon> VER PASE
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
</v-container>
</template>

<script>
//import EmailPaseMedico from '@/components/modals/PasesMedicosDialog.vue'

export default {
    name: "TableReadCitasMedicas",
    components: {
        //EmailPaseMedico
    },
    props: {
        Membresia: {
            type: String,
            required: false,
        },
        reloadTrigger: {
            type: Number,
            default: 0,
            required: false
        },
        resaltarId: String // Recibe el ID a resaltar
    },
    data() {
        return {
            localmembresia: this.Membresia,
            search: '',
            data: [],
            headers: [
                //{ text: "Id", value: "Id", sortable: false },
                { text: "Folio", value: "Folio", sortable: false },
                { text: "Parentesco", value: "Parentesco", sortable: false },
                { text: "Beneficiado", value: "Beneficiado", sortable: false },
                { text: "Especialidad", value: "Especialidad", sortable: true },
                { text: "Medico", value: "Medico", sortable: true },
                { text: "Estatus", value: "FecCierre", sortable: true },
                { text: "Creada", value: "FechaCreacion", sortable: true },
                { text: "Opciones", value: "ops", sortable: false },
            ],
        };
    },
    watch: {
        Membresia(val) {
            this.localmembresia = val
            //val !== null ? this.ObtieneData() : null
        },
        reloadTrigger(val) {
            val !== null ? this.ObtieneData() : null
        }
    },
    created() {
        this.ObtieneData()
    },
    methods: {
        getRowClass(item) {
            return item.Id === this.resaltarId ? 'fila-nueva' : '';
        },
        ObtieneData() {
            if (this.localmembresia) {
                this.$http.get(`membresia/citas${this.localmembresia}`)
                    .then(response => {
                        if (response.status === 200) {
                            this.data = response.data;
                        }
                    })
                    .catch(() => {
                        this.$swal.fire({
                            title: 'Infomación',
                            text: 'No tienes pases sificientes puedes hacer una recarga de 5 a un costo especial contacta a tu agente.',
                            icon: 'warning',
                            confirmButtonText: 'Aceptar',
                            backdrop: false
                        });
                    })
                    .finally(() => {
                    });
            }
        }
    },
};
</script>

<style scoped>
</style>
